<div class="cover" [ngClass]="{'disabled': !canEditProfile}"></div>
<div class="map-container" #map></div>